import { Button } from '../Input2';

import Popup, { type PopupProps } from './Popup';

type DeletePopupProps = PopupProps & {
  onDelete: () => void;
};

type UpdateStepTypePopupProps = DeletePopupProps & {
  showActionCanNotBeUndone?: boolean;
};

export default function UpdateStepTypePopup({
  onClose,
  onDelete,
  showActionCanNotBeUndone = true,
}: UpdateStepTypePopupProps) {
  return (
    <Popup onClose={onClose}>
      <h2 className="text-xl font-bold dark:text-gray-100">Are you sure?</h2>
      <p>
        Updating step type will remove <b>all your formatting</b> and <b>links</b>
      </p>
      {showActionCanNotBeUndone && <p>This action can not be undone</p>}
      <Button color="blue" onClick={onDelete}>
        Yes, Update it
      </Button>
    </Popup>
  );
}

